module.exports = __webpack_public_path__ + "img/avada-fitnes-1.5a9ea8f0.jpg";